module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/stopwatch-002f726b02a011f095dafcd697a5235b.svg";